import { render, staticRenderFns } from "./DialogHistory.vue?vue&type=template&id=4687746c"
import script from "./DialogHistory.vue?vue&type=script&lang=js"
export * from "./DialogHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4687746c')) {
      api.createRecord('4687746c', component.options)
    } else {
      api.reload('4687746c', component.options)
    }
    module.hot.accept("./DialogHistory.vue?vue&type=template&id=4687746c", function () {
      api.rerender('4687746c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplySystem/commodityManagement/dishesManagement/components/DialogHistory.vue"
export default component.exports